import styled from '@emotion/styled';
import { Carousel } from '@zola/zola-ui/src/components/Carousel';
import COLORS3 from '@zola/zola-ui/src/styles/emotion/colors3';
import MEDIA_QUERY_V2 from '@zola/zola-ui/src/styles/emotion/mediaQueryV2';
import SPACING from '@zola/zola-ui/src/styles/emotion/spacing';
import ZINDEX from '@zola/zola-ui/src/styles/emotion/zIndex';

export const StyledCarousel = styled(Carousel)`
  &:hover {
    .slick-prev,
    .slick-next {
      opacity: 1 !important;
    }
  }
  &.zola-ui.carousel__container {
    padding: ${SPACING.S16};

    ${MEDIA_QUERY_V2.MOBILE} {
      padding: ${SPACING.S8};
    }

    height: 100%;

    .slick-slider,
    .slick-list,
    .slick-track,
    .slick-slide {
      height: 100%;
    }
    .slick-slide {
      > div {
        height: 100%;
        width: 100%;
      }
    }

    .slick-prev,
    .slick-next {
      z-index: ${ZINDEX.middle};
      opacity: 0;

      &:focus-visible {
        opacity: 1;
      }
    }
    .slick-prev {
      left: ${SPACING.S16};
    }
    .slick-next {
      right: ${SPACING.S16};
    }
    .slick-prev:before,
    .slick-next:before {
      content: '';
    }
    .slick-list {
      border-radius: 16px;
    }

    .slick-dots {
      bottom: ${SPACING.S16};

      li,
      button,
      .carousel-dot,
      button:before,
      .slick-active .carousel-dot {
        width: 8px;
        height: 8px;
      }

      .carousel-dot {
        border: none;
      }

      li {
        button:before {
          color: ${COLORS3.WHITE_100};
          line-height: 8px;
        }
      }
      .carousel-dot {
        opacity: 0.7;
      }
      .slick-active .carousel-dot {
        background-color: ${COLORS3.WHITE_100};
        opacity: 1;
      }
    }
  }
`;
